/** @module shopping-cart-mini */

import { liveEvents } from '../../../../assets/js/application/index.js';

async function initiallyUpdateMiniCart() {
    try {
        const url = (() => {
                const url = new URL(CONFIG.ajax.url);

                url.searchParams.set('action', 'rlhmf_cart-content-count');

                return url;
            })(),
            response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    ACCEPT: 'application/json',
                },
            });

        if (response.ok) {
            const json = await response.json();

            if (json && json.success && json.data?.fragments) {
                for (const fragment in json.data.fragments) {
                    if (Object.prototype.hasOwnProperty.call(json.data.fragments, fragment)) {
                        const elements = document.querySelectorAll(fragment);

                        elements.forEach((element) => {
                            element.insertAdjacentHTML('beforebegin', json.data.fragments[fragment]);
                            element.parentNode.removeChild(element);
                        });
                    }
                }
            }
        }
    } catch (error) {
        if (window.bugsnagClient) {
            window.bugsnagClient.notify(error);
        }
    }
}

/**
 * Display shopping cart mini
 *
 * Should not be called directly.
 * @private
 * @returns {Promise<void>}
 */
export async function shoppingCartMini() {
    const events = await liveEvents(),
        shoppingCartSelector = '[data-shopping-cart-mini]',
        shoppingCart = document.querySelector(shoppingCartSelector);

    if (shoppingCart) {
        // set loading indicator on item removal
        events.addEventListener(`${shoppingCartSelector} .remove_from_cart_button`, 'click', (event, selector) => {
            event.target.closest(selector).classList.add('is-loading');
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initiallyUpdateMiniCart);
    } else {
        await initiallyUpdateMiniCart();
    }
}
